import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";






const JavaScriptLesson19 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3>Data types</h3>
   <p>Programming languages have in-built data types and structures which differ from one language to another.</p>
   <p>Data types are certain type of inputs that are constrained or restricted to the type of value they can take, the programming language used and the type of operation that can be performed on them.</p>
   <h3>Dynamic Typing</h3>
   <p>JavaScript is a loosely typed programming language. JavaScript variables are not directly associated with any particular value type, and variables of any type can assigned or re-assigned to it.</p>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson19